const InputLabel = ({ label, children, containerClass, ...rest }) => {
  const uid =
    Math.random().toString(36).substring(1, 10) +
    label.replace(/\s/g, "_").toLowerCase();

  return (
    <div className={`flex flex-col ${containerClass || ""}`}>
      <label
        className="text-gray-500 text-sm font-medium break-words"
        htmlFor={uid}
      >
        {label}
      </label>

      <input
        type="text"
        {...rest}
        id={uid}
        className={`w-full bg-gray-100 p-2 border-2 border-gray-400 outline-none rounded-lg focus:border-primary-500 disabled:opacity-50 disabled:bg-gray-300 transition-colors ${rest.className || ""}`}
      />

      {children}
    </div>
  );
};

export default InputLabel;
